import {ElMessage} from 'element-plus';
import {get} from '../http/request';

/**
 * 文件下载Hooks
 *
 * @returns downloadFile
 */
export const useDownload = () => {
  /**
   * 下载上传的文件
   * @param {*} url 下载文件的url
   * @param {*} fileName 下载文件名
   */
  const downloadFile = (url: string, fileName: string) => {
    // console.log('downloadFile', url, fileName);
    // get<Blob>(
    //   url,
    //   {},
    //   {},
    //   {
    //     responseType: 'blob',
    //     transformResponse: function (data) {
    //       return data;
    //     },
    //   },
    // )
    //   .then(res => {
    //     const data = res instanceof Blob ? res : res.data;
    //     if (data instanceof Blob) {
    //       const url = window.URL.createObjectURL(data);
    //       const link = document.createElement('a');
    //       link.style.display = 'none';
    //       link.href = url;
    //       link.setAttribute('download', fileName);
    //       document.body.appendChild(link);
    //       link.click();
    //       document.body.removeChild(link);
    //     } else {
    //       ElMessage.error('下载文件失败');
    //     }
    //   })
    //   .catch(e => {
    //     if (e instanceof Blob) {
    //       const reader = new FileReader();
    //       reader.onload = function () {
    //         ElMessage.error(
    //           reader.result ? JSON.parse(reader.result.toString()).errorMessage : '下载文件失败',
    //         );
    //       };
    //       reader.readAsText(e);
    //     } else {
    //       ElMessage.error('下载文件失败');
    //     }
    //   });
    downloadFileInfo(url, fileName);
  };

  /**
   * 下载上传的文件
   * @param {*} url 下载文件的url
   * @param {*} fileName 下载文件名
   */
  const downloadFileInfo = async (url: string, fileName: string) => {

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`图片下载失败: ${response.statusText}`);
    }

    // 将响应数据转换为 Blob
    const blob = await response.blob();
    // 创建一个指向 Blob 的 URL
    const imgUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = imgUrl;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return {downloadFile, downloadFileInfo};
};
